/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import { fromJS } from 'immutable';

import {
  SET_NOTIFICATIONS,
  SET_NOTIFICATIONS_DATA
} from './constants';
/*
 * routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by moving to react-router-redux@4
 *
 */

const notificationState = fromJS({
  notifications: [],
});



function notificationReducer(state = notificationState, action) {
  switch (action.type) {
    case SET_NOTIFICATIONS:
      const getCurrentNotifications = state.get('notifications').toJS();
      const thisValue = {
        id: new Date().toISOString() + getCurrentNotifications.length,
        value: typeof action.value.value === 'string' ? action.value.value : '',
        type:   action.value.type && action.value.type === 'success' ? 'success' : 'error',
      };
      const setNew = getCurrentNotifications.concat(thisValue);
      return state.set('notifications', fromJS(setNew));
    case SET_NOTIFICATIONS_DATA:
      return state.set('notifications', fromJS(action.payload));
    default:
      return state;
  }
}
/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default notificationReducer;
